import React from 'react';

// components/LoadingOverlay.js
const LoadingOverlay = () => (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-[9999] flex items-center justify-center">
      <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin" />
    </div>
  );
  export default LoadingOverlay;